import 'react';
import clsx from 'clsx';
import { SelectButtonWrapper } from 'reaxl-wallet';
import { sendClick } from 'reaxl-analytics';
import { ndsSelectButtonInteraction } from 'reaxl-analytics-handlers';
import { jsx, Fragment } from 'react/jsx-runtime';
function SelectButtonContainer(_ref) {
  let {
    calcInputs
  } = _ref;
  const renderSelectButtonWrapper = _ref2 => {
    let {
      analyticProps,
      heading,
      width,
      containerElement,
      disabled,
      buttonLabel,
      className,
      children,
      position,
      primaryLabel,
      secondaryLabel,
      hideCTA,
      inputCompletedState,
      onSupportingLinkClick,
      isSupportingLinkClicked,
      ...rest
    } = _ref2;
    const handleDropdownEngagement = () => {
      const {
        cmp
      } = analyticProps || {};
      if (cmp) {
        sendClick(ndsSelectButtonInteraction, {}, {
          cmp
        });
      }
    };
    return /*#__PURE__*/jsx("div", {
      className: clsx({
        'col-xs-12': width === 'full',
        'col-xs-6': width !== 'full'
      }, 'margin-bottom-4'),
      children: /*#__PURE__*/jsx(SelectButtonWrapper, {
        analyticProps: analyticProps,
        buttonLabel: buttonLabel,
        className: className,
        disabled: disabled,
        heading: heading,
        position: position,
        primaryLabel: primaryLabel,
        secondaryLabel: secondaryLabel,
        containerElement: containerElement,
        hideCTA: hideCTA,
        inputCompletedState: inputCompletedState,
        onSupportingLinkClick: onSupportingLinkClick,
        isSupportingLinkClicked: isSupportingLinkClicked,
        onClick: handleDropdownEngagement,
        ...rest,
        children: children
      })
    }, heading);
  };
  return /*#__PURE__*/jsx(Fragment, {
    children: calcInputs.map(item => renderSelectButtonWrapper(item))
  });
}
export { SelectButtonContainer as default };
